module.exports = __webpack_public_path__ + "img/procedencia-tm.47cd3b2f.png";